import React from 'react';
import { Button } from './ui/Button';
import { GlassWater, Plus } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function BundleSection() {
  return <section className="py-5 bg-transparent" data-id="element-61">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62">
        <div className="text-center max-w-3xl mx-auto mb-5" data-id="element-63">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-sage mb-4" data-id="element-64">
            Todo lo que necesitás para tu transformación
          </h2>
          <p className="text-lg text-sage/80" data-id="element-65">
            Un sistema completo diseñado para que no tengas que pensar, solo
            aplicar y disfrutar los resultados.
          </p>
        </div>

        <div className="max-w-5xl mx-auto" data-id="element-66">
          {/* Core Product */}
          <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl border border-sage/5 mb-5 flex flex-col md:flex-row items-center gap-6" data-id="element-67">
            <div className="w-full md:w-2/5 flex justify-center" data-id="element-68">
              <img src="https://cdn.magicpatterns.com/uploads/bNonPf28N1GYLUPsiT7ZGV/ebook.png" alt="Reto 28 Días Sin Inflamación" className="w-3/5 max-w-[220px] object-contain drop-shadow-2xl" data-id="element-69" />
            </div>
            <div className="w-full md:w-3/5" data-id="element-70">
              <div className="inline-block bg-gold/20 text-gold-dark font-bold px-4 py-1 rounded-full text-sm mb-4 uppercase tracking-wider" data-id="element-71">
                PROGRAMA PRINCIPAL
              </div>
              <h3 className="text-3xl font-serif font-bold text-black mb-4" data-id="element-72">
                PROTOCOLO CORE: VIENTRE PLANO 40+
              </h3>
              <p className="text-sage/80 text-lg mb-6" data-id="element-73">
                El manual de Reset paso a paso. Incluye el calendario de 28
                días, las combinaciones antiinflamatorias verificadas y la{' '}
                <span className="font-bold text-sage" data-id="element-74">
                  "Regla de los 2 Días"
                </span>{' '}
                para disfrutar tus comidas favoritas sin retroceder en tus
                resultados. No es una dieta. Es un sistema que se adapta a tu
                vida real.
              </p>
            </div>
          </div>

          <div className="flex justify-center mb-3" data-id="element-75">
            <div className="bg-sage text-white p-2 rounded-full shadow-lg" data-id="element-76">
              <Plus className="w-5 h-5" data-id="element-77" />
            </div>
          </div>

          {/* Accelerators */}
          <div className="grid md:grid-cols-3 gap-4 mb-5" data-id="element-78">
            {/* Accelerator 1 */}
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-sage/5 flex flex-col items-center text-center" data-id="element-79">
              <div className="w-3/5 mx-auto mb-4 flex items-center justify-center overflow-hidden rounded-xl bg-cream" data-id="element-80">
                <img src="https://cdn.magicpatterns.com/uploads/gHKZrUXFHfojZZkDHXRB6G/infusionbono.png" alt="Ritual de Infusiones Fisiológicas" className="w-full h-auto object-contain" data-id="element-81" />
              </div>
              <div className="text-xs font-bold text-gold uppercase tracking-wider mb-2" data-id="element-82">
                Acelerador 1
              </div>
              <h4 className="text-xl font-serif font-bold text-black mb-2" data-id="element-83">
                RITUAL DE INFUSIONES FISIOLÓGICAS (Drenaje 2x)
              </h4>
              <p className="text-sage font-medium text-sm italic mb-3" data-id="element-84">
                "Cómo usar la termogénesis líquida para movilizar toxinas
                estancadas"
              </p>
              <p className="text-sage/80 text-sm leading-relaxed" data-id="element-85">
                El mayor error al intentar desinflamarte es olvidar que tu
                sistema linfático está 'estancado'. Esta Guía de Mezclas
                Terapéuticas activa el filtrado renal y desinflama tus tejidos
                mientras dormís. Sin esta activación, el Reset es un 50% más
                lento.
              </p>
            </div>

            {/* Accelerator 2 */}
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-sage/5 flex flex-col items-center text-center" data-id="element-86">
              <div className="w-3/5 mx-auto mb-4 flex items-center justify-center overflow-hidden rounded-xl bg-cream" data-id="element-87">
                <img src="https://cdn.magicpatterns.com/uploads/uoAoP8oMUsiX6z9hCxnznt/postresbono.png" alt="Reparación Dulce" className="w-full h-auto object-contain" data-id="element-88" />
              </div>
              <div className="text-xs font-bold text-gold uppercase tracking-wider mb-2" data-id="element-89">
                Acelerador 2
              </div>
              <h4 className="text-xl font-serif font-bold text-black mb-2" data-id="element-90">
                REPARACIÓN DULCE: Repostería Anti-Cortisol
              </h4>
              <p className="text-sage font-medium text-sm italic mb-3" data-id="element-91">
                "Neurología aplicada al placer: Cómo comer chocolate y silenciar
                la inflamación"
              </p>
              <p className="text-sage/80 text-sm leading-relaxed" data-id="element-92">
                El estrés dispara el cortisol y paraliza tu digestión. Te
                enseñamos a preparar postres con ingredientes de bajo índice
                glucémico que calman tu sistema nervioso. Disfrutá del dulce sin
                el 'bloating' que arruina tu progreso. Porque si no podés comer
                rico, no lo vas a sostener. Y si no lo sostenés, no hay
                resultado.
              </p>
            </div>

            {/* Accelerator 3 */}
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-sage/5 flex flex-col items-center text-center" data-id="element-93">
              <div className="w-3/5 mx-auto mb-4 flex items-center justify-center overflow-hidden rounded-xl bg-cream" data-id="element-94">
                <img src="https://cdn.magicpatterns.com/uploads/s68RdnbgjpXVemp8uCfgyD/SMOOTHIESBONO3.png" alt="Elixires de Mañana" className="w-full h-auto object-contain" data-id="element-95" />
              </div>
              <div className="text-xs font-bold text-gold uppercase tracking-wider mb-2" data-id="element-96">
                Acelerador 3
              </div>
              <h4 className="text-xl font-serif font-bold text-black mb-2" data-id="element-97">
                ELIXIRES DE MAÑANA (Smoothies de Activación)
              </h4>
              <p className="text-sage font-medium text-sm italic mb-3" data-id="element-98">
                "Logística dominical: Desayunos de biohacking listos en 30
                minutos"
              </p>
              <p className="text-sage/80 text-sm leading-relaxed" data-id="element-99">
                La inflamación se gana o pierde en los primeros 60 minutos del
                día. Diseñamos 20 combinaciones que sellan tu barrera intestinal
                desde temprano. Las mañanas son el momento donde ganás o perdés
                la batalla inflamatoria del día. Ahora las ganás en 5 minutos.
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-100">
            <a href="#resumen-inversion" onClick={e => {
            e.preventDefault();
            document.getElementById('resumen-inversion')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="inline-block" data-id="element-101">
              <Button size="xl" variant="primary" className="px-12 shadow-gold/30" data-id="element-102">
                QUIERO TODO EL PAQUETE AHORA
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>;
}